export const STEP_OPENING_TIME = 1000;

export const STEP_CLOSING_TIME = 1000;

export const STEP_MINIMUM_LOAD_TIME = 1000;
